import * as Luxon from 'luxon';
import {DateRange} from '../../Core/models/DateRange';

export const isEmptyDate = (date: Date | string | undefined | null) =>
  date !== undefined && date !== null && isNaN(Date.parse(date.toString()));

export const toFormattedDate = (date: Date | string | undefined) =>
  date !== undefined && date !== null && !isEmptyDate(date)
    ? Luxon.DateTime.fromJSDate(new Date(date)).toFormat('MM/dd/yyyy')
    : '';

export const toFormattedDateAsUTC = (date: Date | string | undefined) =>
  date !== undefined && date !== null && !isEmptyDate(date)
    ? Luxon.DateTime.fromJSDate(new Date(date), {zone: 'utc'}).toFormat('MM/dd/yyyy')
    : '';

export const toFormattedDateAsISO = (date: Date | string | undefined) =>
  date !== undefined && date !== null && !isEmptyDate(date)
    ? Luxon.DateTime.fromJSDate(new Date(date), {zone: 'utc'}).toFormat('yyyy-MM-dd')
    : '';

export const toFormattedDateTime = (date: Date | string | undefined) =>
  date !== undefined && date !== null && !isEmptyDate(date)
    // @ts-ignore
    ? Luxon.DateTime.fromJSDate(new Date(date)).toLocaleString(Luxon.DateTime.DATETIME_SHORT)
    : '';

export const toFormattedDateRange = (dateRange: DateRange) =>
  !isEmptyDate(dateRange.startDate) || !isEmptyDate(dateRange.endDate)
    ? `${toFormattedDate(dateRange.startDate) || '?'} - ${toFormattedDate(dateRange.endDate) || '?'}`
    : '';

export const toShortDateTimeWithSeconds = (date: Date | string | undefined) =>
  date !== undefined && date !== null && !isEmptyDate(date)
    ? Luxon.DateTime.fromISO(date.toString(), {zone: 'utc'})
        .toLocal()
        // @ts-ignore
        .toLocaleString(Luxon.DateTime.DATETIME_SHORT_WITH_SECONDS)
    : '';

export const toFormattedTimeDuration = (durationStartDate: Date | undefined, durationEndDate: Date | undefined) =>
  durationStartDate !== undefined &&
  durationEndDate !== undefined &&
  !isEmptyDate(durationStartDate) &&
  !isEmptyDate(durationEndDate)
    ? Luxon.Interval.fromDateTimes(new Date(durationStartDate), durationEndDate)
        .toDuration(['hours', 'minutes', 'seconds'])
        .toFormat('hh:mm')
    : '';

export const toFormattedDateAsEst = (date: string | undefined) =>
  date !== undefined && date !== null && !isEmptyDate(date)
    ? Luxon.DateTime.fromISO(date, {zone: 'America/New_York'}).toFormat('MM/dd/yyyy')
    : '';

export const toFormattedDateAsEstWithSeconds = (date: string | undefined) =>
  date !== undefined && date !== null && !isEmptyDate(date)
    ? Luxon.DateTime.fromISO(date, {zone: 'America/New_York'}).toFormat('MM/dd/yyyy HH:mm:ss')
    : '';

export const toFormattedDateTimeAsEST = (date: Date | string | undefined) =>
  date !== undefined && date !== null && !isEmptyDate(date)
    // @ts-ignore
    ? Luxon.DateTime.fromJSDate(new Date(date), {zone: 'America/New_York'}).toLocaleString(Luxon.DateTime.DATETIME_SHORT)
    : '';
